import React, { useEffect, useState } from 'react'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading'
import * as bie from "react-bootstrap";
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik';
import { ERROR_MSG } from '../../CommonUtils/contextVariables';
import * as Yup from 'yup'
import Swal from 'sweetalert2';
import { config } from '../../CommonUtils/CommonURLS';
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import { failureAlert, successAlert2, successAlertRefresh } from '../../CommonUtils/SweetAlerts';
import { useDispatch } from 'react-redux';
import CommonReactTable from '../../CommonUtils/CommonReactTable';
import { FaEdit } from "react-icons/fa";
import { MdDeleteForever } from "react-icons/md";

export default function AfflCourseAdding() {
    const dispatch = useDispatch();
    const AddCOurseValidation = Yup.object().shape({
        courseName: Yup.string().required(ERROR_MSG).nullable(),
        oamdctype: Yup.string().required(ERROR_MSG).nullable(),
        courseCatId: Yup.string().required(ERROR_MSG).nullable(),
        courseGroupCode: Yup.string().required(ERROR_MSG).nullable(),
        labNonlab: Yup.string().required(ERROR_MSG).nullable(),
        duration: Yup.string().required(ERROR_MSG).nullable(),
    });
    const [editData, setEditData] = useState(null);
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            courseName: editData?.course_name ?? "",
            oamdctype: editData?.group_type ?? "",
            courseCatId: editData?.course_cat_id ?? "",
            courseGroupCode: editData?.course_group_code ?? "",
            labNonlab: editData?.lab_nonlab ?? "",
            duration: editData?.duration ?? "",
        },

        validationSchema: AddCOurseValidation,
        onSubmit: (values, { resetForm }) => {
            Swal.fire({
                text: editData ? "Are you sure you want to update?" : "Are you sure you want to submit?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: editData ? "Yes, update it!" : "Yes, submit it!",
                cancelButtonText: "Cancel",
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = editData
                        ? `${config.url.API_URL}saveUpdateCourses/${editData.course_id}`
                        : `${config.url.API_URL}saveCourseNew`;

                    CommonAxiosPost(url, values).then((res) => {
                        if (res?.data?.scode === "01") {
                            successAlert2(res?.data?.sdesc);
                            resetForm();
                            setEditData(null);
                            // GetAddedCourseDetails(0, 0);
                            GetAddedCourseDetails(values.courseGroupCode, values.courseCatId);

                        } else {
                            failureAlert(res?.data?.sdesc);
                        }
                        resetForm();
                        setEditData(null);
                    });
                }
            });
        }

    });

    const [courseGroups, setCourseGroups] = useState([]);
    function GetCoursegroup(clgtype) {
        if (!clgtype) {
            console.warn("clgtype ID is invalid.");
            return;
        }
        let url = config.url.API_URL + `getcouresGroups/` + clgtype;
        CommonAxiosGet(url, dispatch).then((res) => {
            if (res?.data?.scode === '01') {
                setCourseGroups(res?.data?.couresGroup)

            }
        })
    }
    const [courseCategories, setCourseCategories] = useState([]);

    function GetCourseCategory(courseid) {
        if (!courseid) {
            console.warn("Course ID is invalid.");
            return;
        }
        let url = config.url.API_URL + `getcouresCategory/` + courseid;
        CommonAxiosGet(url, dispatch).then((res) => {
            if (res?.data?.scode === '01') {
                setCourseCategories(res?.data?.couresCategory)

            }
        })
    }

    const [reportData, setReportData] = useState([]);

    function GetAddedCourseDetails(groupcode, categoryid) {

        let url = config.url.API_URL + `grantEditCourses/` + groupcode + "/" + categoryid;
        CommonAxiosGet(url, dispatch).then((res) => {
            if (res?.data?.scode === '01') {
                setReportData(res?.data?.grantEditCourses)

            }
        })
    }

    function DeleteCourseDets(courseid, coursename) {
        if (!courseid) {
            console.warn("Course ID is invalid.");
            return;
        }

        Swal.fire({
            title: 'Are you sure?',
            html: `Do you really want to delete this <span style="color: red;">${coursename}</span> with course ID <span style="color: blue;">${courseid}</span>?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel',
        }).then((result) => {
            if (result.isConfirmed) {
                let url = config.url.API_URL + `deleteCourse/` + courseid;
                CommonAxiosPost(url, dispatch).then((res) => {
                    if (res?.data?.scode === '01') {
                        setReportData(res?.data?.grantEditCourses);
                        successAlertRefresh(res?.data?.sdesc)
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error!',
                            text: 'Failed to delete the course.',
                        });
                    }
                }).catch((err) => {
                    console.error("Delete error:", err);

                });
            }
        });
    }



    useEffect(() => {
        GetAddedCourseDetails(0, 0);
    }, [])
    const ReportColumns = [
        {
            Header: "S.No",
            accessor: (row, index) => index + 1,
        },

        {
            Header: "Course ID",
            accessor: "course_id",
        },
        {
            Header: "Course Name",
            accessor: "course_name",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.course_name ?? '-'}</div>
            ),
        },
        {
            Header: "OAMDC Type",
            accessor: "group_type",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.group_type ?? '-'}</div>
            ),
        },
        {
            Header: "Group Code",
            accessor: "course_group_code",
        },
        {
            Header: "Group",
            accessor: "group_name",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.group_name ?? '-'}</div>
            ),
        },
        {
            Header: "Category",
            accessor: "category_name",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.category_name ?? '-'}</div>
            ),
        },
        {
            Header: "Lab",
            accessor: "lab_nonlab",
            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.lab_nonlab ?? '-'}</div>
            ),
        },
        {
            Header: "Duration",
            accessor: "duration",
        },


        {
            // Header: "Actions",
            Header: "Edit  /  Delete",

            Cell: ({ row }) => {
                const rowData = row.original;
                return (
                    <div className="d-flex gap-2">
                        <button type='submit'
                            className="btn btn-primary btn-sm"
                            onClick={() => {
                                setEditData(rowData);
                                GetCoursegroup(rowData.group_type);
                                GetCourseCategory(rowData.course_group_code);
                            }}
                        >
                            <FaEdit size={18} />
                        </button>
                        <button type='button'
                            className="btn btn-danger btn-sm"
                            onClick={() => {
                                DeleteCourseDets(rowData.course_id, rowData?.course_name);

                            }}
                        >
                            <MdDeleteForever size={20} />
                        </button>
                    </div>
                );
            }
        }

    ];

    return (

        <div className="affl-newdiv px-1">
            <CommonFormHeading heading={"Add Course Details"} />

            <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5">
                <FormikProvider value={formik}>
                    <Form onChange={formik.handleChange} onSubmit={formik.handleSubmit} className="affl-form" >



                        <bie.Row>
                            <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                <label className='mb-1'> <b className="field-mandatory">OAMDC/NON- OAMDC</b> </label>
                                <Field as='select' name="oamdctype" className="form-control mb-2"
                                    onChange={(e) => {
                                        formik.handleChange(e);
                                        GetCoursegroup(e.target.value);
                                        formik.setFieldValue("courseGroupCode", "");
                                        formik.setFieldValue("courseCatId", "");
                                        setCourseCategories([]);
                                        setCourseGroups([]);
                                    }}
                                >
                                    <option value=''> --select--</option>
                                    <option value='oamdc'> OAMDC</option>
                                    <option value='non-oamdc'>NON- OAMDC</option>
                                </Field>
                                <ErrorMessage name="oamdctype" component="div" className="text-error" />
                            </bie.Col>


                            <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                <label className='mb-1'> <b className="field-mandatory">Course Group</b> </label>
                                <Field as='select' name="courseGroupCode" className="form-control mb-2"
                                    onChange={(e) => {
                                        formik.handleChange(e);
                                        GetCourseCategory(e.target.value);
                                        formik.setFieldValue("courseCatId", "");
                                    }}
                                >
                                    <option value=''> --select--</option>
                                    {courseGroups.map((group) => (
                                        <option key={group.groupcode} value={group.groupcode}>
                                            {group.main_group}
                                        </option>
                                    ))}
                                </Field>
                                <ErrorMessage name="courseGroupCode" component="div" className="text-error" />
                            </bie.Col>
                            <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                <label className='mb-1'> <b className="field-mandatory">Course Category</b> </label>
                                <Field as='select' name="courseCatId" className="form-control mb-2" onChange={(e) => { GetAddedCourseDetails(formik?.values?.courseGroupCode, e?.target?.value) }}>
                                    <option value=''> --select--</option>
                                    {courseCategories && courseCategories?.map((cat) => (
                                        <option key={cat.course_cat_id} value={cat.course_cat_id}>
                                            {cat.course_cat_name}
                                        </option>
                                    ))}

                                </Field>
                                <ErrorMessage name="courseCatId" component="div" className="text-error" />
                            </bie.Col>
                            <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                <label className='mb-1'> <b className="field-mandatory">Course Name</b> </label>
                                <Field type='text' name="courseName" className="form-control mb-2" maxlength={70} />
                                <ErrorMessage name="courseName" component="div" className="text-error" />
                            </bie.Col>

                            <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                <label className='mb-1'> <b className="field-mandatory">Lab Type</b> </label>
                                <Field as='select' name="labNonlab" className="form-control mb-2" >
                                    <option value=''> --select--</option>
                                    <option value='Lab'> Lab</option>
                                    <option value='Non lab'>Non lab</option>
                                </Field>
                                <ErrorMessage name="labNonlab" component="div" className="text-error" />
                            </bie.Col>
                            <bie.Col xs={12} sm={12} md={12} lg={4} xl={4} xxl={4}>
                                <label className='mb-1'> <b className="field-mandatory">Course duration (Years)</b> </label>
                                <Field as='select' name="duration" className="form-control mb-2" >
                                    <option value=''> --select--</option>
                                    {[2, 3, 4, 5].map((d) => (
                                        <option key={d} value={d}>
                                            {d}
                                        </option>
                                    ))}

                                </Field>
                                <ErrorMessage name="duration" component="div" className="text-error" />
                            </bie.Col>
                        </bie.Row>
                        <button type='submit' className='btn btn-success btn-sm mt-2 float-end'>
                            {editData ? "Update" : "Submit"}
                        </button>
                        {reportData?.length > 0 && (<>
                            <div className="inner-herbpage-service-title-sub mt-5">
                                <h1 className="">Course Report</h1>
                            </div>

                            <div className="table-responsive mt-4">
                                <CommonReactTable data={reportData} columns={ReportColumns} filename="Add Course Details " headerName={`Add Course Details`} />
                            </div>
                        </>
                        )}

                    </Form>
                </FormikProvider>
            </bie.Container>
        </div>
    )
}
